import { useState } from 'react';
import { sendOTP } from '../api';
import TermsContent from './termsContent';
import OtpTermsCondition from './otpTermsCondition';
import { FullPageLoader } from '../../component/helper';
import { useRouteData } from '../RouteDataContext';


const TermsConditionHome = ({ ckey, setPrivacyStatus }) => {

    const [isAccepted, setIsAccepted] = useState(false);
    const [showTerms, setShowTerms] = useState(true);
    const [loading, setLoading] = useState(false);
    // const [status, setStatus] = useState(null);
    const [userToken] = useState(null)
    const { userData } = useRouteData();

    const TermsConditionOtp = async () => {
        setLoading(true);


        const otpData = {
            mobile: userData?.user?.phone,
            company_key: ckey,
            type: 'otp-privacy-policy',
        };

        try {
            const response = await sendOTP(otpData);
            if (response.code === 1) {
                setShowTerms(false);
            } else {
                // setStatus(response.message || 'Failed to send OTP');
            }
        } catch (err) {
            // setStatus('Something went wrong while sending OTP.');
        } finally {
            setLoading(false);
        }
    };

    const resend = () => {
        TermsConditionOtp();
    };

    if (loading) {
        return <FullPageLoader />;
    }

    return (
        <>
            <style>{`
      .userdashboard {
        display: none !important;
      }
    `}</style>

            {showTerms ? (
                <TermsContent
                    isAccepted={isAccepted}
                    setIsAccepted={setIsAccepted}
                    reSendOtp={resend}
                />
            ) : (
                <OtpTermsCondition
                    reSendOtp={resend}
                    setShowTerms={setShowTerms}
                    userToken={userToken}
                    userData={userData}
                    setPrivacyStatus={setPrivacyStatus}
                />
            )}
        </>
    );
};

export default TermsConditionHome;
